const MODULE_NAME = "oncall/";

export const SCHEDULE_STATUS_PAGE_LOAD = `@@${MODULE_NAME}SCHEDULE_STATUS_PAGE_LOAD`;
export const SCHEDULE_STATUS_LOADED = `@@${MODULE_NAME}SCHEDULE_STATUS_LOADED`;

// Creators
export const scheduleStatusPageLoad = () => ({
  type: SCHEDULE_STATUS_PAGE_LOAD,
  payload: {},
});

export const scheduleStatusLoaded = scheduleStatus => ({
  type: SCHEDULE_STATUS_LOADED,
  payload: {
    scheduleStatus,
  },
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/actions/schedule-status.js